import {$, w} from './constants';
gsap.registerPlugin(ScrollTrigger);
const menu_tl = gsap.timeline();
let pager = 0;
let request = true;
const config = { attributes: true, childList: true, subtree: true };
const targetNode = document.getElementById('grid_wrapper');

w.load(() => {
    console.log('Hello world from El Cultivo! --Load');
});

$(document).ready(function() {
    console.log('Hello world from El Cultivo! --Ready');

    /* C O O K I E S */
    if(localStorage.getItem('archivo_cookie')){
        $('#cookies_archivo').addClass('hide');
    }else{
        $('#cookies_archivo').delay(1500).fadeIn(500);
        $('#ok_cookies').click(() => {
            localStorage.setItem('archivo_cookie', 'true');
            $('#cookies_archivo').fadeOut(300).addClass('hide');
        })
    }
    /* END: C O O K I E S */

    /* M E N Ú */
    $('#open_menu').click(function(){
        $(this).toggleClass('active');
        $('#target_menu').fadeToggle(500).addClass('active');
    })
    ScrollTrigger.matchMedia({
        // desktop & tablets
        "(min-width: 768px)": function() {
            if( $('#banner_aux').length ) {
                menu_tl.to('.header--home', {
                    scrollTrigger : {
                        trigger: '.home__aux',
                        scrub: 1,
                        endTrigger: '#banner_aux',
                        start : "start-=87",
                        end : "bottom+=100",
                        markers : false,
                        onEnter: (self) => {
                            $('.header--home').addClass('active');
                            $('.fixer_scroll').addClass('active');
                        },
                        onToggle: (self) => {
                            $('.header--home').toggleClass('active');
                            $('.fixer_scroll').toggleClass('active');
                        },
                        onLeaveBack: (self) => {
                            $('.header--home').removeClass('active');
                            $('.fixer_scroll').removeClass('active');
                        }
                    }
                });
            }
        }
    });
    /* END M E N Ú */

     //Scroll en links de misma página
     $('a[href*="#"]')
     .not('[href="#"]')
     .not('[href="#0"]')
     .click(function(event) {
         if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
             let target = $(this.hash);
             target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
 
             if (target.length) {
                 event.preventDefault();
                 $('html, body').animate({
                     scrollTop: target.offset().top - 120
                 }, 1000);
             }
         }
     });

    /* SINGLE: Slider */

    if( $('#single_slider').length ){
        $('#single_slider').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            autoplaySpeed: 5000,
            infinite: true,
            fade: true,
            cssEase: 'linear',
            arrows: false,
        })
        //->Contador de sliders
        let slidesCount = $('.single-gallery__slide').length;

        if( slidesCount == 1 ){
            $(".arrow").addClass('hide');
            $('.single-gallery__counter-p').text(`1/${slidesCount}`);
        }else{
            $(".arrow--left").addClass('hide');
            $(".arrow--left").click(function () {
                $("#single_slider").slick("slickPrev");
            });
        
            $(".arrow--right").click(function () {
                $("#single_slider").slick("slickNext");
            });
            $(".arrow").on("click", () => {
                let isFirst = $(".slick-slide").first().hasClass("slick-current");
                let isLast = $(".slick-slide").last().hasClass("slick-current");
                isFirst ?($('.arrow--left').addClass('hide'), $('.arrow--left').addClass('slick-disabled')) : ($(".arrow--left").removeClass('hide'), $('.arrow--left').removeClass('slick-disabled'));
                isLast ? ($('.arrow--right').addClass('hide'), $('.arrow--left').addClass('slick-disabled')) : ($('.arrow--left').removeClass('slick-disabled'), $('.arrow--right').removeClass('hide'));
            });
            
    
            $('.single-gallery__counter-p').text(`1/${slidesCount}`);
    
            $('#single_slider').on('init reInit afterChange', (event, slick, currentSlide, nextSlide) => {
                let i = (currentSlide ? currentSlide : 0) + 1;
                $('.single-gallery__counter-p').text(`${i}/${slick.slideCount}`);
                slidesCount = slick.slideCount;
            });
        }
       
    }

    /* END SINGLE: Slider */

    /* Entrevista: B ú s q u e d a */
    $('#search_interview').click(function(){
        $(this).parent().toggleClass('active');
        $(this).toggleClass('active');
        $(this).siblings('.form--search').toggleClass('active');
    })
    /* END Entrevista: B ú s q u e d a */

    /* Entrevista: E t i q u e t a s */
    const call_interviews = ( size = 8, term = null ) => {
        $.ajax({
               type: 'POST',
               dataType: 'html',
               url: cltvo_js_vars.ajax_url,
               data: { 
                   action : 'entrevista', 
                   size: size,
                   page: pager,
                   term_id: term,
               },
               success: function(data){
                if( pager == 0 ){
                    $('#grid_wrapper').html(data);
                    
                }else{
                    
                    $('#grid_wrapper').append( data );
                }
                    pager+=1;
                    onAjaxDoneFilter(data);
                    $('.load_more_filter').click(function(){
                        let term = $(this).data('term');
                        call_interviews( 8, term );
                        console.log('Click Load ' + pager)
                    })
               },
               error: function(errors){
                   console.log( errors );
               }
        });
    }
    const call_interviews_load = ( size = 8, term = null) => {
        if (request) {

			request = false;
            $.ajax({
                type: 'POST',
                dataType: 'html',
                url: cltvo_js_vars.ajax_url,
                data: { 
                    action : 'load', 
                    size: size,
                    page: pager,
                    term_id: term,
                },
                success: function(data){
                    pager+=1;
                    let triggers = ScrollTrigger.getAll();
                    triggers.forEach( trigger => {			
                        trigger.kill(true);
                    });
                    $('#grid_wrapper').append( data );
                    onAjaxDone(data);
                    $('.load_more').click(function(){
                        call_interviews_load();
                    })
                },
                error: function(errors){
                    console.log( errors );
                }
            });
        }
    }

    let onAjaxDone = function() {
		if ($('#max_pages').val() == pager ) {
            console.log('No hay nada que cargar');
            let buttons = document.querySelectorAll('.archive-interviews__load');
            Array.from(buttons).forEach( btn => {
                $(btn).addClass('hide');
            })
			//$('.load_more').parent('.archive-interviews__load').addClass('hide');
			request = false;
		}else{
            console.log('Cargando más...');
            let buttons = document.querySelectorAll('.archive-interviews__load');
            Array.from(buttons).forEach( btn => {
                $(btn).addClass('hide');
            })
            let btn_last = buttons[buttons.length - 1];
            $(btn_last).removeClass('hide');
			//$('.load_more').parent('.archive-interviews__load').removeClass('hide');
			request = true;

		}

	}
    let onAjaxDoneFilter = function() {
		if ($('#max_pages').val() == pager ) {
            console.log('No hay nada que cargar')
			$('.load_more_filter').parent('.archive-interviews__load').addClass('hide');
			request = false;


		}else{
            console.log('Cargando más...')
			$('.load_more_filter').parent('.archive-interviews__load').removeClass('hide');
			request = true;

		}

	}
    $('#tags_show').click(function(){
        $(this).toggleClass('active');
        $('#tags_target').slideToggle(200).toggleClass('show');
    })
    $('.tag_filter').click(function(){
        pager = 0;
        $('#tags_show').addClass('in_use');
        $('.tag_filter').removeClass('active');
        $(this).addClass('active');
        let term = $(this).data('tag');
        let name = $(this).data('tag-name');
        console.log('Term: ' + term );
		call_interviews( 8, term );
        $('#tags_in_use').text( name );
        $('#tags_target').slideToggle(400).toggleClass('show');
    })
    if( $('#grid_wrapper').length){
        console.log('Carga entrevistas');
        call_interviews_load();
        $('.load_more').click(function(){
            console.log('Click Load ' + pager)
            call_interviews_load();
        })
        $('.load_more_filter').click(function(){
            let term = $(this).data('term');
            call_interviews( 8, term );
            console.log('Click Load ' + pager)
        })
    }

    gsap.registerPlugin(ScrollTrigger);
    const prev_tl = gsap.timeline();

    const load_more_filter_scroll = ( obj ) =>{
        ScrollTrigger.refresh(true);
        let term = $(obj).data('term');
        prev_tl.to(obj, {
            scrollTrigger : {
                trigger: obj,
                start: 'start 50%',
                end: 'bottom 50%',
                markers: false,
                refreshPriority: 1,
                scrub: false,
                once: true
            }
        }).call(call_interviews( 8, term ))
    }
    const load_more_scroll = ( obj ) =>{
        ScrollTrigger.refresh(true);
        prev_tl.to(obj, {
            scrollTrigger : {
                trigger: obj,
                start: 'start 50%',
                end: 'bottom 50%',
                markers: true,
                refreshPriority: 1,
                scrub: false,
                once: true
            }
        }).call(call_interviews_load())
    }
    /* END Entrevista: E t i q u e t a s */

})
